import { atom } from 'jotai'

export const tipoDocumentos = atom([]);